/* eslint @typescript-eslint/explicit-function-return-type: off */

export const indexPath = (projectId) =>
  `/projects/${projectId}/csv_import_jobs`;
export const createPath = indexPath;
export const detailsPath = (projectId, jobId) =>
  `/projects/${projectId}/csv_import_jobs/${jobId}`;
